import { SkeletonBox } from 'components/skeletonBox';
import styles from './BannerHero.module.scss';
import classNames from 'classnames';
import React from 'react';

export const BannerHeroSkeleton = () => (
  <SkeletonBox
    data-testid="banner-hero-skeleton"
    className={classNames(styles.skeleton)}
    noPaddingTop
    noPaddingBottom
  />
);

export const BannerHeroSwiperSkeleton = () => (
  <div data-testid="banner-hero-skeleton-panel" className={styles.skeletonPanel}>
    <BannerHeroSkeleton />
    <div
      className={classNames(
        'swiper-pagination',
        'swiper-pagination-clickable',
        'swiper-pagination-bullets',
        'swiper-pagination-horizontal'
      )}
    >
      <span
        className={classNames(styles.bulletBanner, 'swiper-pagination-bullet', 'swiper-pagination-bullet-active')}
      ></span>
      <span className={classNames(styles.bulletBanner, 'swiper-pagination-bullet')}></span>
      <span className={classNames(styles.bulletBanner, 'swiper-pagination-bullet')}></span>
    </div>
  </div>
);
